var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfieDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.1272 95.1272C93.2363 91.2 89.5418 81.6 89.8908 74.6181C90.3272 65.8909 88.1453 63.2727 84.218 57.1636C80.2908 51.0545 75.9271 41.4545 76.3635 35.7818C76.5164 33.7944 76.2943 32.3961 75.885 31.4181M65.4545 91.2C61.9635 77.9345 68.0726 65.6271 71.5635 61.1316C69.5843 57.4831 67.7586 52.2729 67.1999 45.3818C66.1526 32.4654 70.5453 29.2363 72.8726 29.2363C73.723 29.2363 75.126 29.6047 75.885 31.4181M75.885 31.4181C74.8809 31.4181 73.1344 32.7272 74.1817 37.9636",
    stroke: "#0F90FF",
    strokeWidth: 0.872727
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5093 38.3999C17.4548 38.5454 11.3457 39.7963 11.3457 43.6363C11.3457 47.4763 17.4548 48.7272 20.5093 48.8726M20.5093 53.6726C17.8912 54.109 13.0912 56.1029 13.0912 60.6544C13.0912 63.709 18.1821 64.5817 20.5093 63.709M20.5093 67.6363C18.473 67.9272 14.4002 69.2944 14.4002 72.4363C14.4002 75.5781 18.473 77.2363 20.5093 77.6726",
    stroke: "#0F90FF",
    strokeWidth: 0.872727
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6906 92.5093C46.1088 91.9275 44.8579 90.3275 44.5088 88.582",
    stroke: "#0F90FF",
    strokeWidth: 0.872727
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0732 5.23636C20.0732 2.3444 22.4176 0 25.3096 0H61.9641C64.8561 0 67.2005 2.3444 67.2005 5.23636V35.6244C66.6503 38.0456 66.427 41.2421 66.7655 45.4171C66.8694 46.6981 67.0167 47.922 67.2005 49.0895V67.9253C66.1274 70.4211 65.1698 73.3345 64.5823 76.5236V5.23636C64.5823 4.27238 63.8009 3.49091 62.8369 3.49091H24.4369C23.4729 3.49091 22.6914 4.27237 22.6914 5.23636V84.6545C22.6914 85.6185 23.4729 86.4 24.4369 86.4H62.8369C63.3312 86.4 63.7775 86.1945 64.0951 85.8643C64.1666 86.7058 64.2715 87.5555 64.4132 88.4114C63.6824 88.7988 62.8489 89.0182 61.9641 89.0182H25.3096C22.4176 89.0182 20.0732 86.6738 20.0732 83.7818V5.23636Z",
    fill: "#9EA1B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.6543,
    y: 1.74561,
    width: 14.8364,
    height: 5.23636,
    rx: 1.74545,
    fill: "#9EA1B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6543,
    y: 11.3452,
    width: 13.9636,
    height: 1.74545,
    fill: "#9EA1B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9277,
    y: 73.3091,
    width: 31.4182,
    height: 7.85455,
    rx: 3.92727,
    fill: "#0F90FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5459,
    y: 15.709,
    width: 26.1818,
    height: 0.872727,
    fill: "#C3C6DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7451 42.3271H46.2542M47.9997 44.509H47.1269",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6358 27.9272C47.1267 27.9272 54.1085 29.9345 54.1085 37.9636V47.9298C54.1085 50.782 53.0343 53.5274 51.0998 55.6231L47.4835 59.5407C45.4101 61.7869 41.8615 61.7869 39.7881 59.5407L36.1719 55.6231C34.2373 53.5274 33.1631 50.782 33.1631 47.9298V37.9636C33.1631 29.9345 40.1449 27.9272 43.6358 27.9272Z",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1629 44.0727C32.1448 43.4909 30.1084 43.0254 30.1084 45.8182C30.1084 49.3091 31.8539 51.0545 33.5993 51.0545",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1085 44.0776C55.1267 43.4958 57.1631 43.0303 57.1631 45.823C57.1631 49.314 55.4176 51.0594 53.6722 51.0594",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9629 42.3271H41.4538M39.7083 44.509H40.5811",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3263 49.7456C42.9082 50.0365 44.3336 50.4438 45.3809 49.7456M40.1445 51.9274C40.4354 52.3638 41.5409 53.2365 43.6354 53.2365C46.0085 53.2365 47.1263 52.3638 47.5627 51.9274M42.7627 54.5456H45.3809",
    stroke: "#C3C6DB",
    strokeWidth: 0.872727
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieDocument);
export default __webpack_public_path__ + "static/media/selfie-document.c933f89e1a41ca84843a544a42bf1894.svg";
export { ForwardRef as ReactComponent };